<template>
  <b-container class="communes">
    <h1 class="titre">Prochains passages<br/>{{ this.$route.params.idZone }}</h1>
    <h2 class="selection_arret">Sélectionnez l'arrêt de votre choix :</h2>
    <div class="div_loader" v-if="loading">
      <b-spinner class="loader" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="liste_arret row">
      <div v-for="(stopName, key) in stops" :key="stopName" class="col-lg-3 col-md-4 col-12">
        <b-btn :to="{name: 'ProchainPassage', params: {stopName: stopName}}" class="arret">
          <span class="nom_arret">{{ (key + 1) + " - " + stopName }}</span>
        </b-btn>
      </div>
    </div>
  </b-container>
</template>

<script>
  import router from '../router'

  export default {
    name: 'Arrets',
    data () {
      return {
        stops: null,
        loading: false
      }
    },
    methods: {
      goToProchainPassageSiUnSeulArret: function () {
        if (this.stops.length === 1) {
          router.replace('arret=' + this.stops[0])
        }
      }
    },
    mounted () {
      this.loading = true
      this.axios.get('/listStops')
        .then((succes) => {
          this.stops = succes.data
          this.loading = false
          this.goToProchainPassageSiUnSeulArret()
        }, (error) => {
          console.error('ERREUR', error.body)
        })
    }
  }
</script>

<style lang="scss">
@import "src/sass/app";

.communes {
  text-align: center;
  margin-top: 3rem;

  .titre {
    color: $secondcolor;
    font-family: $titlefont;
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 2rem;
  }

  .selection_arret {
    color: $firstcolor;
    font-family: $textfont;
    font-size: 30px;
  }

  .div_loader {
    display: flex;
    margin: 4rem 0;
    @include media-breakpoint-up(sm) {
      height: 0;
    }

    .loader {
      margin: auto;
      color: $secondcolor;
      width: 6rem;
      height: 6rem;
    }
  }

  .liste_arret {
    justify-content: center;
    margin-top: 2rem;
    display: flex;

    .arret {
      height: 100px;
      border: 2px solid $secondcolor;
      background-color: white;
      border-radius: 10px;
      color: $secondcolor;
      font-family: $titlefont;
      font-size: 20px;
      margin: 15px 0;
      padding: 1rem;
      text-decoration: none;
      display: flex;
      @include media-breakpoint-between(md, lg) {
        height: 125px;
      }

      .nom_arret {
        margin: auto;
      }
    }

    .arret:hover {
      background-color: $secondcolor;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Arrets.vue